<template>
  <div class="app-container">
    <el-breadcrumb separator-class="el-icon-arrow-right" style="margin-bottom: 5px;padding-left: 10px">
      <el-breadcrumb-item v-for="item in breadList">
        <span style="color:#006fff;cursor:pointer" @click="goCurrentTab(item)">{{ item.fileShowName }}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <el-table
        v-loading="loading"
        :data="fileData"
        style="width: 100%"
        height="350px"
        row-style="height:35px"
        highlight-current-row
        @current-change="handleCurrentChange"
    >
      <el-table-column
          label="目录/文件"
      >
        <template slot-scope="scope">
          <i class="el-icon-folder-opened" style="color:#006fff" v-if="scope.row.directoryType===true"></i>&nbsp
          <span style="cursor:pointer" @click="getSubDirectory(scope.row)">{{ scope.row.fileShowName }}</span>
        </template>
      </el-table-column>
      <el-table-column
          prop="createTime"
          sortable
          label="文件类型"
          width="110"
      >
        <template slot-scope="scope">
          {{ getFileType(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column
          prop="modifyTime"
          sortable
          label="更新时间"
          width="150">
      </el-table-column>
      <el-table-column
          label="操作"
          width="100">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="viewFile(scope.row)">查看</el-button>
          <el-button type="text" size="small" @click="downloadFile(scope.row)" v-if="scope.row.directoryType===false">下载</el-button>
        </template>
      </el-table-column>
    </el-table>
    <span style="padding-top: 15px;display: block;padding-left: 10px">{{chooseInfo}}</span>
    <!--对话框：浏览PDF文件-->
    <el-dialog
        :visible="showPdf === true"
        :append-to-body='true'
        :modal-append-to-body='true'
        :lock-scroll='true'
        :destroy-on-close='true'
        :close-on-click-modal='false'
        width='80%'
        style="z-index: 111"
        :before-close="closePreviewClick"
        top="200px"
        center>
      <div v-if="showPdf === true" class="dialog-body-content-base-style"
           style="justify-content: center; align-items: center">
        <embed :src="this.fileUrl" style="width: 100%; height: 700px"/>
      </div>
    </el-dialog>
    <!--对话框：浏览 视频/图片/音频/文档-->
    <el-dialog
        :append-to-body="true"
        :visible="showDoc === true   || showImg === true || showVideo === true || showMp3 === true"
        :show-close='true'
        width="600"
        style="margin-top: 10px;z-index: 111"
        class="dialog-div-pre-style"
        :before-close="closePreviewClick"
        center>
      <div v-if="showDoc === true" class="dialog-body-content-base-style" style="justify-content: center; align-items: center">
        <iframe frameborder="0"
                :src="'https://view.officeapps.live.com/op/view.aspx?src=' + this.fileUrl"
                width='100%'>
        </iframe>
      </div>
      <div align="center" v-else-if="showImg === true">
        <img :src="this.fileUrl" @load="onLoadImg" :height="boxHeight" :width="boxWidth"/>
      </div>
      <div v-else-if="showVideo === true" align="center" class="dialog-body-content-base-style" style="justify-content: center; align-items: center">
        <video :src="this.fileUrl" controls autoplay class="video" height="350"></video>
      </div>
      <div v-else-if="showMp3 === true" align="center" class="dialog-body-content-base-style">
        <audio :src="this.fileUrl" autoplay="autoplay" controls="controls" ref="audio" style="width: 70%"></audio>
      </div>
      <div align="center" style="margin-top: 10px;font-weight: bold">{{this.filePlayName}}</div>
    </el-dialog>
  </div>
</template>
<script>
import {
  getUserDirectoryList,
  getFileInfo
} from "@/api/system/netDisk/netDisk";
import Vue from "vue";
import storage from "good-storage";
import {USER_KEY} from "@/assets/constant";
import {downloadFile} from "@/utils/OSSUpload";
import {getCloudUrl} from "@/utils/urlutil";

export default Vue.extend({
  components: {},
  data() {
    return {
      loading:false,
      userData: null,
      userId: null,
      pageNumber: 1,
      pageSize: 0,
      parentId: 0,
      fileData: [],
      breadList: [{directoryId: 0, fileShowName: '根目录'}],
      currentDirectoryId: 0,
      currentRow:null,
      chooseInfo:'',
      //浏览文件配置参数
      showMp3:   false,
      showImg:   false,
      showDoc:   false,
      showPdf:   false,
      showVideo: false,
      fileUrl:    "",
      boxWidth: "",
      boxHeight:"",
      filePlayName:"",      //文件完整名称
    }
  },
  created() {
    this.userData = storage.get(USER_KEY)
    this.getUserDirectoryList()
  },
  methods: {
    getFileType(row) {
      if (row.directoryType === true) {
        return '/'
      } else {
        return row.fileSuffix
      }
    },
    getUserDirectoryList() {
      if (this.userData.UserID !== null && this.userData.UserID !== undefined) {
        this.loading=true
        getUserDirectoryList({
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          parentId: this.parentId,
          objUserId: this.userData.UserID,
          sortName: 'directoryType'
        }).then((res => {
          if (res.code === 200) {
            this.fileData = res.data.rows
          }
          this.loading=false
          this.currentRow=null
          this.chooseInfo=''
        }))
      }
    },
    getSubDirectory(row) {

      if (row.directoryType === true) {
        this.loading=true
        getUserDirectoryList({
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          parentId: row.directoryId,
          objUserId: this.userData.UserID,
          sortName: 'directoryType'
        }).then((res => {
          if (res.code === 200) {
            this.fileData = res.data.rows
            this.breadList = [{directoryId: 0, fileShowName: '根目录'}]
            if (res.data.parentLevelList.length > 0) {
              this.breadList = this.breadList.concat(res.data.parentLevelList)
            }
            this.currentDirectoryId = row.directoryId
          }
          this.currentRow=null
          this.chooseInfo=''
          this.loading=false
        }))
      }
    },
    goCurrentTab(item) {
      console.log(item)
      console.log(this.currentDirectoryId)
      if (item.directoryId !== this.currentDirectoryId) {
        this.loading=true
        getUserDirectoryList({
          pageNumber: this.pageNumber,
          pageSize: this.pageSize,
          parentId: item.directoryId,
          objUserId: this.userData.UserID,
          sortName: 'directoryType'
        }).then((res => {
          if (res.code === 200) {
            this.fileData = res.data.rows
            this.breadList = [{directoryId: 0, fileShowName: '根目录'}]
            if (res.data.parentLevelList.length > 0) {
              this.breadList = this.breadList.concat(res.data.parentLevelList)
            }
            this.currentDirectoryId = item.directoryId
          }
          this.currentRow=null
          this.chooseInfo=''
          this.loading=false
        }))
      }
    },
    handleCurrentChange(val) {
      this.currentRow = val;
      this.chooseInfo = '已选中：'+val.fileShowName
    },
    viewFile(file){
      if(file.directoryType === true){
        // 如果是目录则进入文件夹里
        this.getSubDirectory(file)
      } else {
        // 如果是文件则访问文件
        this.filePlayName=file.fileShowName+file.fileSuffix;
        let type = this.iconByType(file);
        this.fileUrl = this.config.RESOURCES+file.fileUrl;
        console.log(this.config.RESOURCES)
        console.log(file.fileUrl)
        console.log(this.fileUrl)
        // if (type.indexOf("doc") !== -1 || type.indexOf("docx") !== -1 || type.indexOf("xls") !== -1 || type.indexOf("xlsx") !== -1) {
        //   this.showDoc = true;
        // }
       if (type.indexOf("pdf") !== -1) {
          this.showPdf = true;
        }
        else if (type.indexOf("jpg") !== -1 || type.indexOf("png") !== -1 || type.indexOf("jpeg") !== -1) {
          this.showImg=true;
        }
        else if (type.indexOf("avi") !== -1 || type.indexOf("mp4") !== -1 || type.indexOf("webm") !== -1 || type.indexOf("m4v") !== -1 || type.indexOf("rmvb") !== -1 || type.indexOf("mpg") !== -1 || type.indexOf("3gp") !== -1 || type.indexOf("swf") !== -1 || type.indexOf("mkv") !== -1) {
          this.showVideo = true;
        }
        else if (type.indexOf("mp3")!== -1){
          this.showMp3 = true;
        }
        else {
          this.$message("当前文件暂不支持预览")
        }
      }
    },
    /**
     * 下载文件
     * @param file
     */
    downloadFile(file){
      if(file.directoryType === false){
        downloadFile(getCloudUrl(file.fileUrl))
      }
    },
    /**
     * 经过文件后缀返回文件的图标
     */
    iconByType(row) {
      return row.fileSuffix.substring(row.fileSuffix.lastIndexOf(".") + 1, row.fileSuffix.length).toLowerCase()
    },
    //关闭预览文件对话框
    closePreviewClick() {
      if (this.showDoc === true) {
        this.showDoc = false;
      } else if (this.showPdf === true) {
        this.showPdf = false;
      } else if (this.showVideo === true) {
        this.showVideo = false;
      } else if (this.showImg === true) {
        this.showImg = false;
      } else if (this.showMp3 === true) {
        this.showMp3 = false;
      }
    },
    // 预览图片时调整图片预览大小
    onLoadImg: function (e) {
      const imgURL = this.fileUrl;
      const res = new Image();
      res.src = imgURL;
      if (res.naturalHeight / res.naturalWidth > 1) {
        this.boxHeight = 500 + 'px';
        this.boxWidth = Math.floor(500 * res.naturalWidth / res.naturalHeight) + 'px';
      } else if (res.naturalHeight / res.naturalWidth === 1) {
        if (res.naturalHeight > 500) {
          this.boxHeight = 500 + 'px';
          this.boxWidth = 500 + 'px';
        } else {
          this.boxWidth = res.naturalWidth + 'px';
          this.boxHeight = res.naturalHeight + 'px';
        }
      } else if (res.naturalWidth / res.naturalHeight > 1) {
        this.boxWidth = 650 + 'px';
        this.boxHeight = Math.floor(650 * res.naturalHeight / res.naturalWidth) + 'px';
      }
      this.$forceUpdate();
    },
  }
})
</script>
<style scoped>
</style>
